<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card flat class="pt-2" min-height="300">
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text>
        <div v-if="isLoading">
          <v-skeleton-loader type="list-item-avatar-two-line" v-for="i in 3" :key="i" class="py-2"/>
        </div>
        <v-list v-else>
          <template v-for="(stop, index) in routePlan.route_plan_locations">
            <v-list-item class="p-2" :key="index">
              <v-list-item-avatar>
                <v-icon v-if="stop.location" class="grey" dark>
                  {{ stop.location.vuetifyIcon }}
                </v-icon>
                <v-icon v-else class="grey" dark>mdi-help</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  <router-link v-if="stop.location" :to="'/location/' + stop.location.id" class="d-flex align-center" target="_blank">
                    {{ stop.location.label }}
                    <v-icon color="primary" small class="ml-1">mdi-open-in-new</v-icon>
                  </router-link>
                  <span v-else>{{ stop.location_code }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <multi-time-display :time="stop.eta"/>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text color="primary" @click="showDialog = false">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'

export default {
  name: 'RouteStopsDialog',
  components: {
    MultiTimeDisplay
  },
  data () {
    return {
      showDialog: false,
      isLoading: true,
      routePlan: null,
      title: ''
    }
  },
  methods: {
    /**
     * Load the full route plan (including all stops information, which is the main reason for this dialog)
     * @param routePlanId
     * @param title
     */
    async loadRoutePlan (routePlanId, title) {
      this.routePlan = null
      this.isLoading = true
      this.title = title
      this.showDialog = true
      try {
        this.routePlan = await this.$orm('RoutePlan').find(routePlanId, {
          params: {
            expand: 'route_plan_locations.location'
          }
        })
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
